import { Avatar, Box, Flex, Text } from "@radix-ui/themes";
import { FC } from "react";

import { formatRacingTime } from "../../../../utils/formatRacingTime";
import { LeaderboardItemProps } from "./LeaderboardItem.types";

// Podium colour per rank (1st/2nd/3rd). Anything below 3 renders a plain pill.
const MEDAL_BY_RANK: Record<number, string> = {
  1: "sr-row__rank--gold",
  2: "sr-row__rank--silver",
  3: "sr-row__rank--bronze",
};

const LeaderboardItem: FC<LeaderboardItemProps> = ({ item, gap }) => {
  if (!item) return null;

  const rank = item.userChallengeData?.rank ?? 0;
  const isLeader = rank === 1;
  const onPodium = rank >= 1 && rank <= 3;

  // F1-style team name when present, otherwise fall back to the retail store.
  const team =
    item.userChallengeData?.gameSpecificData?.teamName || item.profile?.storeName;

  return (
    <Flex
      className={`sr-row ${onPodium ? "sr-row--podium" : ""} ${
        isLeader ? "sr-row--leader" : ""
      }`}
      align="center"
      gap="3"
      px="4"
      py="3"
    >
      <Box className={`sr-row__rank ${MEDAL_BY_RANK[rank] ?? ""}`}>{rank}</Box>

      <Avatar
        className="sr-row__avatar"
        radius="full"
        size="3"
        src={item.profile?.avatarUrl}
        fallback={item.profile?.userName?.[0] ?? "?"}
      />

      <Box flexGrow="1" minWidth="0">
        <Text as="p" size="4" weight="bold" truncate style={{ color: "white" }}>
          {item.profile?.userName}
        </Text>
        {team && (
          <Text as="p" size="1" truncate className="sr-row__team">
            {team}
          </Text>
        )}
      </Box>

      <Flex direction="column" align="end" gap="0">
        <Text size="5" weight="bold" className="sr-time" style={{ color: "white" }}>
          {formatRacingTime(item.userChallengeData?.points)}
        </Text>
        {isLeader ? (
          <Text size="1" weight="bold" className="sr-row__gap sr-row__gap--leader">
            LEADER
          </Text>
        ) : gap ? (
          <Text size="1" className="sr-row__gap sr-time">
            {gap}
          </Text>
        ) : null}
      </Flex>
    </Flex>
  );
};

export default LeaderboardItem;
